import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import { mapGetters } from 'vuex';
export default {
  name: 'TasksCalendar',
  mounted() {
    this.calendar = new Calendar(this.$el, {
      events: this.tasksCalendar,
      plugins: [dayGridPlugin],
      eventClick: info => {
        this.$emit('click', info.event);
      }
    });
    this.calendar.render();
  },
  methods: {
    resize() {
      this.calendar.updateSize();
    }
  },
  computed: {
    ...mapGetters('tasks', ['tasksCalendar'])
  }
};